// src/pages/Committee.js
import React from 'react';
import './Committee.css';

// --- Import ONLY AVAILABLE Images Directly ---
import AashaTiwari from '../assets/committee/Aasha-Tiwari-100.jpg';
import PritiPande from '../assets/committee/Priti-Pande-100.jpg';
import KavitaThakare from '../assets/committee/Kavita-Ajay-Thakare-100.jpg';
// Assuming 'narmadabai-murodiya.jpg' is NOT available, so no import here
import SavitribaiChobe from '../assets/committee/Savitribai-Chobe-100.jpg';
// Assuming 'archana-sharma.jpg' is NOT available, so no import here
import VijaylaxmiBatho from '../assets/committee/Vijaylaxmi-Narendra-Batho-100.jpg';
// --- End Image Imports ---

function Committee() {
  const committeeMembers = [
    {
      name: 'Sau. Aasha Dyashankar Tiwari',
      designation: 'President',
      imageUrl: AashaTiwari
    },
    {
      name: 'Sau. Priti Krupashankar Pande',
      designation: 'Vice President',
      imageUrl: PritiPande
    },
    {
      name: 'Sau. Kavita Ajay Thakare',
      designation: 'Secretary',
      imageUrl: KavitaThakare
    },
    {
      name: 'Sau. Narmadabai Jagannath Murodiya',
      designation: 'Join-Secretary',
      imageUrl: null // Set to null if image is not available
    },
    {
      name: 'Sau. Savitri Ramakant Chaubey',
      designation: 'Treasurer',
      imageUrl: SavitribaiChobe
    },
    {
      name: 'Sau. Archana Sunil Sharma',
      designation: 'Member',
      imageUrl: null // Set to null if image is not available
    },
    {
      name: 'Shrimati Vijaylaxmi Narendra Batho',
      designation: 'Member',
      imageUrl: VijaylaxmiBatho
    },
  ];

  return (
    <div className="committee-page">
      {/* --- Hero Section --- */}
      <section className="committee-hero-section">
        <h1 className="committee-hero-heading">Our Committee</h1>
        <p className="committee-hero-subheading">
          Meet the dedicated individuals guiding our organization.
        </p>
      </section>

      <div className="container">
        <section className="committee-section">
          <h2 className="committee-section-title">Leadership Team</h2>
          <div className="committee-table-container">
            <table>
              <thead>
                {/* FIX: No whitespace between <tr> and <th> */}
                <tr><th></th><th>Name</th><th>Designation</th></tr>
              </thead>
              <tbody>
                {committeeMembers.map((member, index) => (
                  // FIX: No whitespace between <tr> and <td>
                  <tr key={index}><td>
                      {member.imageUrl ? (
                        <img
                          src={member.imageUrl}
                          alt={member.name}
                          className="member-profile-image"
                        />
                      ) : (
                        <div className="member-avatar-placeholder">
                          <i className="fas fa-user-circle"></i>
                        </div>
                      )}
                    </td><td>{member.name}</td><td>{member.designation}</td></tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>
      </div>
    </div>
  );
}

export default Committee;